import React, { useState } from 'react';
import Modal from '@mui/material/Modal';
// import { reactPlugin } from '../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { jsonEditorStyles } from './components/jsonEditor/jsonEditorStyles';
import cn from 'clsx';
import Button from '@mui/material/Button';
import { Box, Link, Typography } from '@mui/material';
import { TextComponent } from './components/uiComponents';

interface TOSUIProps {
  closeComponent: any;
}

const TOSUIComponent = ({ closeComponent }: TOSUIProps) => {
  const classes: any = jsonEditorStyles();
  const [email, setEmail] = useState<string>(localStorage.getItem('userEmailId') || '');
  return (
    <Modal
      disablePortal
      disableEnforceFocus
      disableAutoFocus
      open
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          closeComponent();
        }
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className={classes.modalStyle}
    >
      <div className={classes.popup}>
        <div className={cn(classes.header)}>
          <div className={cn(classes.flexRow, classes.alignCenter)}>
            <Typography variant="h6">Welcome to the Visual Authentication Journey Builder</Typography>
          </div>
        </div>

        <div>
          <div className={cn(classes.flexCol)}>
            <Typography variant="h6" sx={{ py: 1, pl: 2 }}>
              Before getting started with the editor, please watch the{' '}
              <Link
                sx={{ cursor: 'pointer' }}
                onClick={() => {
                  window.open('https://youtu.be/Zf6OduB3oyY', '_blank');
                }}
              >
                introductory video
              </Link>
              .
            </Typography>
            <Typography variant="h6" sx={{ py: 1, pl: 2 }}>
              Don't hesitate to{' '}
              <Link
                sx={{ cursor: 'pointer' }}
                onClick={() => {
                  window.open(
                    'https://calendly.com/gritiam/demo-of-visual-authentication-journey-builder-clone',
                    '_blank',
                  );
                }}
              >
                schedule a call
              </Link>{' '}
              with us for a demo, assistance, or further inquiries.
            </Typography>
            <Typography variant="body1" sx={{ py: 1, pl: 2 }}>
              This is a shared sandbox environment, please do not upload any confidential data.
            </Typography>
            <Typography variant="body1" sx={{ py: 1, pl: 2 }}>
              By using this website you are accepting our{' '}
              <a
                href="https://gritsoftwaresystemscom-my.sharepoint.com/:w:/g/personal/lingesh_gritsoftwaresystems_com/ERdIy6GMRdJJqVkwABhJEhMB8tLb6BdvLO6dxl6T8GRo-Q?e=0JOhOp"
                target="_blank"
              >
                terms of service
              </a>
              .
            </Typography>
            <Typography variant="body1" sx={{ py: 1, pl: 2 }}>
              Please join{' '}
              <a
                href="https://join.slack.com/t/gritsoftwaresystemshq/shared_invite/zt-1kvxj8vao-wVuVE1oUyhcez2EY~UcZrA"
                target="_blank"
              >
                our Slack channel
              </a>{' '}
              and our experts will provide answers for your technical questions about Azure AD B2C XML or about CIAM
              architecture in general. There is no cost to this service.
            </Typography>
            <TextComponent
              changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
                setEmail(e.target.value);
              }}
              data={{
                style: { marginLeft: 2, width: 500, marginTop: 4 },
                value: email,
                helperText: 'Provide your email address to continue.',
                label: 'Email Address',
              }}
            />
          </div>
          <Box sx={{ py: 2 }} className={cn(classes.flexSpacedRow)}>
            <div style={{ flex: '2' }} />
            <Button
              sx={{ flexBasis: '0', flex: '1' }}
              variant="contained"
              disabled={email === ''}
              onClick={() => {
                closeComponent();
                localStorage.setItem('userEmailId', email);
              }}
            >
              OK
            </Button>
            <div style={{ flex: '2' }} />
          </Box>
        </div>
      </div>
    </Modal>
  );
};

// export default withAITracking(reactPlugin, TOSUIComponent);
export default TOSUIComponent;
